import { render, staticRenderFns } from "./checkboxItem.vue?vue&type=template&id=c51b943a"
import script from "./checkboxItem.vue?vue&type=script&lang=js"
export * from "./checkboxItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports